module.exports = __webpack_public_path__ + "assets/img/checked.b1e816a0.svg";